var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-orange",class:[{'w-100' : _vm.fullWidth }, _vm.variant],on:{"click":function($event){$event.preventDefault();return _vm.$emit('onClick', 'event')}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }